import React from 'react';

import './SectionTitle.scss';
import Icon from 'Core/Components/Icon';

class SectionTitle extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { pane, icon, children, text } = this.props;
    return (
      <h2 className="SectionTitle">
        {icon ? <Icon fa={icon}/> : null}
        {pane ? <span className="faded">{pane} </span> : null}
        {children}
        {text}
      </h2>
    )
  }
};

SectionTitle.defaultProps = {
  pane: null,
  icon: 'chevron-right',
  children: null,
  text: null
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Common/SectionTitle/SectionTitle.jsx